import React from 'react';
const SupportIcon: React.FC = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        d="M1.5 3.9C1.5 2.76863 1.5 2.20294 1.85147 1.85147C2.20294 1.5 2.76863 1.5 3.9 1.5H5.1C6.23137 1.5 6.79706 1.5 7.14853 1.85147C7.5 2.20294 7.5 2.76863 7.5 3.9V5.1C7.5 6.23137 7.5 6.79706 7.14853 7.14853C6.79706 7.5 6.23137 7.5 5.1 7.5H3.9C2.76863 7.5 2.20294 7.5 1.85147 7.14853C1.5 6.79706 1.5 6.23137 1.5 5.1V3.9Z"
        fill="#42C5A6"
      />
      <path
        d="M8.5 3.9C8.5 2.76863 8.5 2.20294 8.85147 1.85147C9.20294 1.5 9.76863 1.5 10.9 1.5H12.1C13.2314 1.5 13.7971 1.5 14.1485 1.85147C14.5 2.20294 14.5 2.76863 14.5 3.9V5.1C14.5 6.23137 14.5 6.79706 14.1485 7.14853C13.7971 7.5 13.2314 7.5 12.1 7.5H10.9C9.76863 7.5 9.20294 7.5 8.85147 7.14853C8.5 6.79706 8.5 6.23137 8.5 5.1V3.9Z"
        fill="#0A9AF8"
      />
      <path
        d="M1.5 10.9C1.5 9.76863 1.5 9.20294 1.85147 8.85147C2.20294 8.5 2.76863 8.5 3.9 8.5H5.1C6.23137 8.5 6.79706 8.5 7.14853 8.85147C7.5 9.20294 7.5 9.76863 7.5 10.9V12.1C7.5 13.2314 7.5 13.7971 7.14853 14.1485C6.79706 14.5 6.23137 14.5 5.1 14.5H3.9C2.76863 14.5 2.20294 14.5 1.85147 14.1485C1.5 13.7971 1.5 13.2314 1.5 12.1V10.9Z"
        fill="#FDB814"
      />
      <path
        d="M8.5 10.9C8.5 9.76863 8.5 9.20294 8.85147 8.85147C9.20294 8.5 9.76863 8.5 10.9 8.5H12.1C13.2314 8.5 13.7971 8.5 14.1485 8.85147C14.5 9.20294 14.5 9.76863 14.5 10.9V12.1C14.5 13.2314 14.5 13.7971 14.1485 14.1485C13.7971 14.5 13.2314 14.5 12.1 14.5H10.9C9.76863 14.5 9.20294 14.5 8.85147 14.1485C8.5 13.7971 8.5 13.2314 8.5 12.1V10.9Z"
        fill="#A6A6A6"
      />
    </svg>
  );
};

export default SupportIcon;
